module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"sidebar":{"titulo":"Selection","inicio":"Start date","duracion":"Duration","selec_fecha":"Select a date","dias":"days","meses":"months","lista_vacia":"No billboards selected"}},"es":{"sidebar":{"titulo":"Selección de espacios","inicio":"Inicio","duracion":"Duración","selec_fecha":"Seleccionar fecha","dias":"días","meses":"meses","lista_vacia":"No hay vallas seleccionadas"}}}')
  delete Component.options._Ctor
}
